import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { Page, PageHeader, PageInner, PageSection } from "@app/shared";
import { RoleRestricted, Roles } from "@app/user";
import MemberSetService from "./memberSetService";
import { QESButton, QESCheckbox } from "@app/shared/qes-standards";

interface CreateMemberSetState {
  description: string;
  name: string;
  isPrivate: boolean;
}

export default class CreateMemberSet extends React.Component<RouteComponentProps<unknown>, CreateMemberSetState> {
  private readonly memberSetService = new MemberSetService();

  constructor(props: RouteComponentProps<unknown>) {
    super(props);

    this.state = {
      description: "",
      isPrivate: true,
      name: "",
    };
  }

  public handleCancel = (): void => {
    this.props.history.goBack();
  }

  public handleNameChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      name: e.currentTarget.value,
    });
  }

  public handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    this.setState({
      description: e.currentTarget.value,
    });
  }

  public handleIsPrivateChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      isPrivate: e.currentTarget.checked,
    });
  }

  public handleFormSubmit = async (e: React.FormEvent<HTMLButtonElement>): Promise<void> => {
    e.preventDefault();

    const { name, description, isPrivate } = this.state;
    await this.memberSetService.create(name, description, isPrivate);

    this.props.history.goBack();
  }

  public render() {

    return (
      <Page documentTitle="Create Member Population">
        <PageInner>
          <PageHeader title="Create Member Population..." />
          <PageSection>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <form className="form-horizontal" >

                    <div className="form-group row">
                      <label className="col-sm-2 col-form-label" htmlFor="memberSetName">Name</label>
                      <div className="col-sm-4">
                        <input
                          id="memberSetName"
                          type="text"
                          className="form-control"
                          placeholder="Member Population Name"
                          onChange={this.handleNameChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-2 col-form-label" htmlFor="memberSetDescription">Description</label>
                      <div className="col-sm-4">
                        <textarea
                          id="memberSetDescription"
                          className="form-control"
                          placeholder="Member Population Description"
                          rows={4}
                          onChange={this.handleDescriptionChange}
                        />
                      </div>
                    </div>
                    <RoleRestricted allowedRoles={[Roles.RESOURCE_ADMIN]}>
                      <div className="form-group row">
                        <QESCheckbox
                          containerClassName="offset-sm-2 col-sm-4"
                          label="This is a Private Project (can be administered only by you)"
                          checked={this.state.isPrivate}
                          onChange={this.handleIsPrivateChange}
                          testId="member-set-create__private"
                        />
                      </div>
                    </RoleRestricted>
                    <div className="form-group row mt30">
                      <div className="offset-sm-2 col-sm-4">
                        <QESButton qesTestId="member-set-create_create" onClick={this.handleFormSubmit}>Create</QESButton>
                        <QESButton qesTestId="member-set-create_cancel" qesType="primary-danger" className="ml10" onClick={this.handleCancel}>Cancel</QESButton>
                      </div>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </PageSection>
        </PageInner>
      </Page>
    );
  }
}
